module.exports = __webpack_public_path__ + "img/sld_cb_ta1_ba1_dark.701af7d7.svg";